import CheckCircleFilled from '@mui/icons-material/CheckCircle'
import CloseIcon from '@mui/icons-material/Close'
import ErrorFilled from '@mui/icons-material/Error'
import { Alert, AlertColor, Button, Snackbar } from '@mui/material'
import { useSnackbar } from '../hooks/useSnackbar'

const DEFAULT_ANCHOR_ORIGIN = {
  vertical: 'top' as const,
  horizontal: 'right' as const
}
const AUTO_HIDE_DURATION = 6000

const SEVERITY_ICONS: Record<AlertColor, React.ReactElement | undefined> = {
  success: <CheckCircleFilled sx={{ color: 'success.dark' }} />,
  error: <ErrorFilled sx={{ color: 'error.dark' }} />,
  warning: undefined,
  info: undefined
}

const SEVERITY_BACKGROUNDS: Record<AlertColor, string> = {
  success: '#A5D6A7',
  error: '#ef9a9a',
  warning: '#ffb74d',
  info: '#90caf9'
}

export const SharedSnackbar = () => {
  const { snackbarData, open, closeSnackbar } = useSnackbar()

  if (!snackbarData) return null

  const { severity, message, anchorOrigin } = snackbarData

  const getAlertSx = () => {
    if (!severity) return {}

    const baseStyles = {
      backgroundColor: SEVERITY_BACKGROUNDS[severity]
    }

    if (severity === 'error') {
      return {
        ...baseStyles,
        color: 'black',
        '& .MuiAlert-message': {
          color: 'black'
        }
      }
    }

    return baseStyles
  }

  const getAlertIcon = () => {
    if (!severity) return undefined
    return SEVERITY_ICONS[severity]
  }

  return (
    <Snackbar
      open={open}
      anchorOrigin={anchorOrigin || DEFAULT_ANCHOR_ORIGIN}
      autoHideDuration={AUTO_HIDE_DURATION}
      onClose={closeSnackbar}
      message={message}
      action={
        <Button
          color='inherit'
          onClick={closeSnackbar}
          sx={severity === 'error' ? { color: 'black' } : {}}
        >
          <CloseIcon />
        </Button>
      }
    >
      <Alert
        severity={severity}
        variant='filled'
        onClose={closeSnackbar}
        icon={getAlertIcon()}
        sx={getAlertSx()}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}
